export const enum ModelDataHighlight {
  LINK_HEAD = 'LINK_HEAD',
  LINK_TAIL = 'LINK_TAIL',
}
